module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p1s4titles":[{"titleS":false,"title":"Reviews,"},{"titleS":true,"title":"opinions and experiences"},{"titleS":false,"title":"of trainees at AICAD Business School"}]},"es":{"p1s4titles":[{"titleS":false,"title":"Reseñas,"},{"titleS":true,"title":"opiniones y experiencias"},{"titleS":false,"title":"de alumnos en prácticas en AICAD Business School"}]}}')
  delete Component.options._Ctor
}
